// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1OPvH","list":"PatternAutocomplete_list__1_v27"};